/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { getUproColor } from "utils/colors";

const getRows = (data, handleClick) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
            data={
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color:
                    item.estado === "Aprobado"
                      ? getUproColor("uproGreen")
                      : getUproColor("uproPink"),
                }}
                fontSize="lg"
              >
                {item.estado === "Aprobado" ? "thumb_up" : "thumb_down"}
              </Icon>
            }
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip title={item.estado} placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color:
                      item.estado === "Aprobado"
                        ? getUproColor("uproGreen")
                        : getUproColor("uproPink"),
                  }}
                  fontSize="lg"
                >
                  {item.estado === "Aprobado" ? "thumb_up" : "thumb_down"}
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        fecha: (
          <SoftBox
            data={dayjs(item?.fecha).format("DD/MM/YYYY")}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {dayjs(item?.fecha).format("DD/MM/YYYY")}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            data={item.estado}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item.estado}
            </SoftTypography>
          </SoftBox>
        ),
        resultado: (
          <SoftBox
            data={item.resultado}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item.resultado}
            </SoftTypography>
          </SoftBox>
        ),
        usuario: (
          <SoftBox
            data={`${item.usuario.nombre} ${item.usuario.apellido}`}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {`${item.usuario.nombre} ${item.usuario.apellido}`}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => handleClick(item)}
            display="flex"
          >
            <Tooltip title="Ver detalles" placement="top">
              <Icon
                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={() => handleClick(item)}
              >
                arrow_forward
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "fecha", desc: "Fecha", align: "left", noOrder: true },
  { name: "estado", desc: "Estado", align: "left", noOrder: true },
  { name: "resultado", desc: "Puntaje", align: "left", noOrder: true },
  { name: "usuario", desc: "Creado por", align: "left", noOrder: true },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
